import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HamburgerMenu.css';
import { useNavigate } from 'react-router-dom';

// Import icons (assuming you're using some icon library)
// If you don't have an icon library, you can add one like:
// npm install react-icons
import { FaUserShield, FaChartBar, FaSignOutAlt, FaKey } from 'react-icons/fa';

const HamburgerMenu = () => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef();
    const navigate = useNavigate();

    const userProfile = localStorage.getItem('userProfile');
    const user = localStorage.getItem('user');
    // get first character of user name
    const userInitial = user ? user.charAt(0).toUpperCase() : '';

    const handleLogout = () => {
        // clear local storage
        localStorage.clear();
        // redirect to login page
        navigate('/');
    }

    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
        // Add/remove body scroll lock when menu is open
        if (!isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && 
                !event.target.classList.contains('user-initial-avator') && 
                !event.target.classList.contains('hamburger')) {
                setMenuOpen(false);
                document.body.style.overflow = '';
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        
        // Cleanup function
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = '';
        };
    }, [menuRef]);

    useEffect(() => {
        // Clean up any body style changes when component unmounts
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    return (
        <>
            {/* Overlay when menu is open */}
            <div 
                className={`menu-overlay ${isMenuOpen ? 'active' : ''}`} 
                onClick={() => {
                    setMenuOpen(false);
                    document.body.style.overflow = '';
                }}
            />

            {user ? (
                <button className="user-initial-avator" onClick={toggleMenu}>
                    {userInitial}
                </button>
            ) : (
                <button className="hamburger" onClick={toggleMenu}>
                    ☰
                </button>
            )}
            
            <div ref={menuRef} className={`menu ${isMenuOpen ? 'open' : ''}`}>
                <button className="close" onClick={toggleMenu}>×</button>
                
                <div>
                    <Link className="menu-button" to="/Admin" onClick={toggleMenu}>
                        <FaUserShield className="menu-icon" /> Admin
                    </Link>
                </div>
                
                <div>
                    <Link className="menu-button" to="/Site" onClick={toggleMenu}>
                        <FaChartBar className="menu-icon" /> Data View
                    </Link>
                </div>
                
                <div>
                    <Link className="menu-button" to="/Licensing" onClick={toggleMenu}>
                        <FaKey className="menu-icon" /> Licensing
                    </Link>
                </div>
                
                {user && (
                    <div>
                        <button className="menu-button" onClick={() => {
                            handleLogout();
                            toggleMenu();
                        }}>
                            <FaSignOutAlt className="menu-icon" /> Logout
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}

export default HamburgerMenu;